import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { productKeys } from './keys';

import type { TypeGetCategoriesCodeParentCodeResponse } from '~/types/product.types';

/**
 * [상품관리] 상위코드로 하위 카테고리 조회 API
 * @param parentCode 상위 카테고리 코드
 */
export const fetchCategoriesCodesParentCode = async (parentCode: string | null) => {
  const endpoint = '/api-lip/v1/categories/codes';
  const { data } = await axiosInstance.get<TypeGetCategoriesCodeParentCodeResponse>(`${endpoint}/${parentCode}`);
  return data.data;
};

type UseGetCategoriesCodesParentCodeQueryOptions = {
  parentCode: string | null;
  enabled?: boolean;
  dimmed?: boolean;
};

/**
 * [상품관리] 상위코드로 하위 카테고리 조회 Query Hook
 * @description 상위 카테고리가 결정된 경우 사용한다.
 */
export const useGetCategoriesCodesParentCodeQuery = ({
  parentCode,
  enabled = true,
  dimmed = true,
}: UseGetCategoriesCodesParentCodeQueryOptions) => {
  return useQuery({
    queryKey: productKeys.categoriesCodes(parentCode),
    queryFn: () => fetchCategoriesCodesParentCode(parentCode),
    staleTime: 1000 * 60 * 30, // 30분
    enabled: enabled && !!parentCode,
    meta: { dimmed },
  });
};
